import { AxiosRequest } from 'src/lib/axios/Axios';

export const updatePaymentState = async ({
  order_id,
  payment_state_id,
  operation_order_id,
  marketplace_id,
  comments,
  attachments,
  link_payments,
  payment_gateway_id,
}: {
  order_id: string;
  payment_state_id: string;
  operation_order_id: string;
  marketplace_id: string;
  comments?: string;
  attachments?: any[];
  link_payments?: string[];
  payment_gateway_id?: string | null;
}) => {
  const response = await AxiosRequest.post('/operation/status', {
    order_id,
    payment_state_id,
    operation_order_id,
    marketplace_id,
    comments,
    attachments,
    link_payments,
    payment_gateway_id,
  });

  return response.data;
};
